import * as Sentry from '@sentry/react'

import { printError } from '../print'

export enum BaseErrorTypes {
  UNKNOWN = 'unknown',
}

export class BaseError extends Error {
  public readonly cause: Error

  constructor({ cause, message }: { cause?: Error; message?: string }) {
    super(message || cause?.message || 'UNKNOWN')
    this.cause = cause || new Error(this.message)
    Sentry.captureException(this)
    this.print()
  }

  print(): void {
    printError(this.cause, { persistInProd: true })
  }
}
